import { motion } from "framer-motion";
import { WaIcon } from "./WaIcon";
import { waLink } from "@/lib/site";

export const FloatingWa = () => (
  <motion.a
    href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="floating-whatsapp-btn" aria-label="Escribir por WhatsApp"
    initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 1.6, type: "spring", stiffness: 220, damping: 16 }}
    whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.95 }}
    className="fixed bottom-4 right-4 z-50 flex h-16 w-16 items-center justify-center gap-2 rounded-full bg-[#25D366] font-bold text-[#0F2321] shadow-[0_14px_34px_rgba(37,211,102,.45)] sm:bottom-5 sm:right-5 sm:w-auto sm:pl-4 sm:pr-5"
  >
    <span className="relative flex">
      <span className="ping-soft absolute inset-0 rounded-full bg-white/60" />
      <WaIcon className="relative h-8 w-8" />
    </span>
    <span className="hidden text-[16px] sm:inline">¿Hablamos?</span>
  </motion.a>
);
